import React, { useEffect, useState } from 'react';
import axios from '../api/axios';
import Sidebar from '../components/Sidebar';

function AccountLedger() {
  const [accountId, setAccountId] = useState('');
  const [logs, setLogs] = useState([]);

  const fetchLedger = () => {
    if (!accountId) return;
    axios.get(`/accounts/ledger/${accountId}`).then(res => setLogs(res.data));
  };

  useEffect(() => {
    if (accountId) fetchLedger();
  }, [accountId]);

  return (
    <div className="flex">
      <div className="p-6 w-full">
        <h2 className="text-2xl font-bold mb-4">Multi-Account Ledger</h2>
        <input
          placeholder="Enter Account ID"
          className="border p-2 mb-4 w-full"
          value={accountId}
          onChange={e => setAccountId(e.target.value)}
        />
        <table className="table-auto w-full text-left border">
          <thead className="bg-gray-100">
            <tr>
              <th className="p-2 border">Type</th>
              <th className="p-2 border">Reference</th>
              <th className="p-2 border">Debit</th>
              <th className="p-2 border">Credit</th>
              <th className="p-2 border">Date</th>
            </tr>
          </thead>
          <tbody>
            {logs.map(log => (
              <tr key={log.id}>
                <td className="p-2 border">{log.type}</td>
                <td className="p-2 border">{log.reference}</td>
                <td className="p-2 border text-red-600">{log.debit}</td>
                <td className="p-2 border text-green-600">{log.credit}</td>
                <td className="p-2 border">{new Date(log.created_at).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default AccountLedger;